<template>
  <el-form
    ref="form"
    :model="form"
    :rules="FormRules"
    class="container-fluid mb-2"
    label-position="top"
  >
    <el-row>
      <el-col>
        <el-form-item
          label="Título"
          class="w-100"
          prop="title"
          :error="errors.title"
        >
          <el-input
            v-model="form.title"
            clearable
            name="title"
            show-word-limit
            maxlength="190"
            placeholder="Título"
          />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item
          label="Fonte do vídeo"
          class="w-100"
          prop="role_id"
        >
          <el-select
            v-model="form.source"
            class="w-100"
            placeholder="Selecionar a origem do vídeo"
          >
            <el-option
              v-for="item in ['vimeo', 'videohub']"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item
          label="Url do vímeo"
          class="w-100"
          prop="content"
          :error="errors.content"
        >
          <el-input
            v-model="form.content"
            clearable
            name="embed"
            show-word-limit
            maxlength="190"
            placeholder="Url do video no vimeo"
          />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item
          label="Id do videohub"
          class="w-100"
          prop="content"
          :error="errors.videohub_content"
        >
          <el-input
            v-model="form.videohub_content"
            clearable
            name="embed"
            show-word-limit
            maxlength="190"
            placeholder="id do video no videohub"
          />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item
          label="Transcriçãoo"
          class="w-100"
          prop="transcription"
          :error="errors.transcription"
        >
          <ckeditor
            v-model="form.transcription"
            :editor="editor"
          />
        </el-form-item>
      </el-col>
     
      
      <el-col>
        <el-form-item
          label="Capítulos"
          class="w-100"
          prop="chapters"
          :error="errors.chapters"
        >
          <ckeditor
            v-model="form.chapters"
            :editor="editor"
          />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item
          label="Subtópicos"
          class="w-100"
          prop="subtopics"
          :error="errors.subtopics"
        >
          <ckeditor
            v-model="form.subtopics"
            :editor="editor"
          />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item
          label="Resumo"
          class="w-100"
          prop="summary"
          :error="errors.summary"
        >
          <ckeditor
            v-model="form.summary"
            :editor="editor"
          />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item
          label="Questões"
          class="w-100"
          prop="questions"
          :error="errors.questions"
        >
          <ckeditor
            v-model="form.questions"
            :editor="editor"
          />
        </el-form-item>
      </el-col>
      <el-col>
        <el-button
          type="primary"
          @click="onSubmit"
        >
          Salvar
        </el-button>
        <el-button
          type="warning"
          @click="$emit('cancel')"
        >
          Cancelar
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import RequestErrors from "@/admin/utils/RequestErrors";
import FormRules from "./FormRules";
import editor from '@/admin/utils/Editor'

export default {
  mixins:[ RequestErrors ],
  data() {
    return {
      FormRules,
      editor,
    }
  },
  computed: {
    ...mapGetters(['video']),
    form: {
      get() {
        return this.$store.state.video.current;
      },
      set(video) {
        this.SET_VIDEO(video);
      }
    }
  },
  methods: {
    ...mapActions(['getVideo','createVideo','updateVideo']),
    onSubmit() {

      this.$refs['form'].validate((valid) => {
        if (valid) {

          const action = this.video.id ? this.updateVideo({data: this.form, id: this.video.id}) : this.createVideo({data: this.form});
          this.$loading();
          action
            .then(() => {
              this.$message({
                message: 'Video salvo com sucesso.',
                type: 'success',
              });
              this.$emit('onSave')
            })
            .catch(e=>{
              this.showDefaultErrorMessages(e);
            })
            .finally(()=>this.$loading().close());
          } else {
          return false;
        }
      });
    },
    setForm(video) {
      this.form = video;
    },
  },
}
</script>
<style >
.ck-editor__editable {
    min-height: 300px;
    max-height: 300px;
}
</style>